"use client";
//#region packages/@mantine/core/src/components/ScrollArea/utils/to-int.ts
function toInt(value) {
	return value ? parseInt(value, 10) : 0;
}
//#endregion
export { toInt };

//# sourceMappingURL=to-int.mjs.map